// extracted by css-extract-rspack-plugin
export default {"cls1":"dossier-cls1_O2Y","cls2":"dossier-cls2_dqD dossier-cls1_O2Y"};